let endpoints = {
  TEAMLIST: "user_view/teamlist",
  GALLERYLIST: "user_view/gallerylist",
  PROJECTLIST: "user_view/projectlist",
  CONTACTCREATE: "contact_us/create",
  HOMEBANNERLIST: "user_view/bannerlist",
  CONSTRUCTIONLIST: "user_view/constructionlist",
  CONSTRUCTIONSERVICELIST: "user_view/get-service-adv-img",
  OURSTORYLIST: "user_view/get-ourstory-img",
};

let API_EP_BOOK = {
  TEAMLIST_API_EP: {
    url: endpoints.TEAMLIST,
    method: "POST",
    authorization: false,
  },
  GALLERYLIST_API_EP: {
    url: endpoints.GALLERYLIST,
    method: "POST",
    authorization: false,
  },
  PROJECTLIST_API_EP: {
    url: endpoints.PROJECTLIST,
    method: "POST",
    authorization: false,
  },
  CONTACTCREATE_API_EP: {
    url: endpoints.CONTACTCREATE,
    method: "POST",
    authorization: false,
  },
  HOMEBANNERLIST_API_EP: {
    url: endpoints.HOMEBANNERLIST,
    method: "POST",
    authorization: false,
  },
  CONSTRUCTIONLIST_API_EP: {
    url: endpoints.CONSTRUCTIONLIST,
    method: "POST",
    authorization: false,
  },
  CONSTRUCTIONSERVICELIST_API_EP: {
    url: endpoints.CONSTRUCTIONSERVICELIST,
    method: "GET",
    authorization: false,
  },
  OURSTORYLIST_API_EP: {
    url: endpoints.OURSTORYLIST,
    method: "GET",
    authorization: false,
  },
};
export default API_EP_BOOK;
